import { Component, Inject, OnInit } from '@angular/core';
import { OrgTreeActionsDirective } from '../../directives/org-tree-actions.directive';
import { OrgTreeService } from '../../services/org-tree.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrganisationCommunicationType } from '../../../../shared/enums/OrganisationCommunicationType';
import { compare, distinctArray } from '../../../../shared/helpers/helpers';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import moment from 'moment';
import { Moment } from 'moment';
import { ModuleService } from '../../../../shared/services/module.service';
import { DialogService } from '../../../../shared/services/dialog.service';
import { FaqService } from '../../../../shared/services/faq.service';
import { SnackService } from '../../../../shared/services/snack.service';
import { TranslateService } from '@ngx-translate/core';
import { IFaq } from '@shared/interfaces';
import { IS_PRODUCT_SAFETY_PROJECT, IS_TRS_PROJECT } from '../../../../../current-project';

@Component({
    selector: 'app-timeline',
    templateUrl: './timeline.component.html',
    styleUrls: ['./timeline.component.scss'],
    standalone: false
})
export class TimelineComponent extends OrgTreeActionsDirective implements OnInit {
    IS_TRS_PROJECT = IS_TRS_PROJECT;
    IS_PRODUCT_SAFETY_PROJECT = IS_PRODUCT_SAFETY_PROJECT;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { dates: ITimelineItem[] },
        orgTreeService: OrgTreeService,
        moduleService: ModuleService,
        private faqService: FaqService,
        private translate: TranslateService,
        private dialogService: DialogService,
        private snack: SnackService
    ) {
        super(orgTreeService, moduleService);
    }

    ngOnInit(): void {
        this.sortItems();
    }

    sortItems() {
        this.data.dates = distinctArray<ITimelineItem>(this.data.dates, 'title').sort(
            (a, b) =>
                compare(a.sortOrder, b.sortOrder) || compare(moment(a.date)?.unix() ?? 0, moment(b.date)?.unix() ?? 0)
        );
    }

    changeDateForCommunication(type: OrganisationCommunicationType, date: Date) {
        const mailDate = this.data.dates.find(e => e.mailType === type);

        if (!mailDate) {
            return;
        }

        mailDate.date = date;
        this.sortItems();
    }

    openInfoModal() {
        let freezeDateFaqItem: IFaq | null;

        parentLoop: for (const faqItem of this.faqService.faqItems) {
            // loop over nested faq items when available
            for (const nestedFaqItem of faqItem.items || []) {
                // find the faq item describing Freeze date

                if (
                    nestedFaqItem.title[`${this.translate.currentLang}`] === 'Release date for the report form' ||
                    nestedFaqItem.title[`${this.translate.currentLang}`] === 'Freigabedatum des Berichtsformulars'
                ) {
                    freezeDateFaqItem = nestedFaqItem;
                    break parentLoop;
                }
            }
        }

        // no freeze date found => show error
        if (!freezeDateFaqItem) {
            this.snack.openSnackBarError(this.translate.instant('faq.noFreezeFoundError'));

            return;
        }

        const title = freezeDateFaqItem?.title[`${this.translate.currentLang}`];
        const content = freezeDateFaqItem?.content[`${this.translate.currentLang}`];

        this.dialogService.openDialog({ title: title, message: content, confirmText: 'Close', hideCancelButton: true });
    }
}

export interface ITimelineItem {
    date?: Date | Moment;
    title: string;
    hasNoDate?: boolean;
    mailType?: OrganisationCommunicationType;
    sortOrder?: number;
    color?: string;
    icon?: IconProp | string[];
    onClick?: (type: ITimelineItem) => void;
    tooltip?: string;
}
